import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowRight } from '../../../../assests/images/LandingAssets/ArrowRight.svg';
import { ReactComponent as ArrowLeft } from '../../../../assests/images/LandingAssets/ArrowLeft.svg';
import { ReactComponent as ProfileImage } from '../../../../assests/images/LandingAssets/ProfileImage.svg';
import { ReactComponent as SophiaProfile } from '../../../../assests/images/LandingAssets/SophiaProfile.svg';
import { ReactComponent as DanielProfile } from '../../../../assests/images/LandingAssets/DanielProfile.svg';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};
export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 20px 0;
  @media only screen and ${device.tablet} {
    padding-left: 48px;
    padding-right: 24px;
  }
`;

const Container = styled.div`
  display: flex;
  gap: 20px;
  padding-left: 80px;
  margin-top: 34px;
  overflow-x: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  @media only screen and ${device.tablet} {
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    scrollbar-height: none;
    padding-left: 0px;
    padding-right: 15px;
  }
  @media only screen and ${device.desktop} {
    padding-left: none;
    justify-content: center;
  }
`;

const Card = styled.div`
  border-radius: 20px;
  padding: 15px;
  background: linear-gradient(
    90deg,
    rgba(242, 242, 242, 0.3) 0%,
    rgba(99, 99, 99, 0.3) 100%
  );
  scroll-snap-align: center;
  display: flex;
  flex-direction: column;
  @media only screen and ${device.tablet} {
    flex: 0 0 230px;
    padding: 30px 20px 30px 20px;
  }
`;

const CardTitle = styled.div`
  font-family: Inter;
  font-weight: 600;
  font-size: 24px;

  vertical-align: middle;
  color: #f2f2f2;
  text-align: left;
`;

const CardText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;

  vertical-align: middle;
  color: #f2f2f2;
  margin-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  width: 468px;
  @media only screen and ${device.tablet} {
    width: 268px;
  }
`;

const Image = styled.img`
  width: 468px;
  height: 280px;
  border-radius: 10px;
  margin-bottom: 15px;
  @media only screen and ${device.tablet} {
    max-width: 268px;
    object-fit: cover;
  }
`;
const CarousalCards = ({ containerRef }) => {
  const cards = [
    {
      title: 'Hospitality',
      text: 'Increased guest satisfaction and revenue through proactive engagement',
      ProfileImage: require('../../../../assests/images/LandingAssets/Hospitality-min.jpg'),
    },
    {
      title: 'Healthcare',
      text: 'Enhanced patient satisfaction through proactive sentiment analysis ',
      ProfileImage: require('../../../../assests/images/LandingAssets/Healthcare-min.jpg'),
    },
    {
      title: 'Automotive',
      text: 'Faster adaptation to consumer demand shifts, driving higher conversion rates',
      ProfileImage: require('../../../../assests/images/LandingAssets/Automotive-min.jpg'),
    },
  ];
  return (
    <Wrapper>
      <Container ref={containerRef}>
        {cards.map((card, index) => (
          <Card key={index}>
            <Image src={card?.ProfileImage} />
            <CardTitle>{card.title}</CardTitle>
            <CardText>{card.text}</CardText>
          </Card>
        ))}
      </Container>
    </Wrapper>
  );
};

export default CarousalCards;
